import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import CoursesList from "./pages/CoursesList";
import SearchResults from "./pages/SearchResults";
import TicketsList from "./pages/TicketsList";
import TicketDetail from "./pages/TicketDetail";
import Assignments from "./pages/AssignmentsPage";
import Game from "./pages/StudentGame";
import CourseView from "./components/CourseView";
import CalendarView from "./components/CalendarView";
import Layout from "./components/Layout";
import Login from "./components/Login";
import RequireAuth from "./components/RequireAuth";
import ProtectedRoute from "./ProtectedRoute";
import "./styles/main.css";

function App() {
  // ✅ Fetch the logged-in user (stored after Google login)
  const storedUser = localStorage.getItem("loggedInUser");
  const user = storedUser ? JSON.parse(storedUser) : null;

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/calendar" element={<CalendarView />} />
                  <Route path="/course/:courseId" element={<CourseView />} />
                  <Route path="/courses" element={<CoursesList />} />
                  <Route path="/search" element={<SearchResults />} />
                  <Route path="/tickets" element={<TicketsList />} />
                  <Route path="/tickets/:ticketId" element={<TicketDetail />} />
                  <Route path="/assignments" element={<Assignments />} />

                  {/* 🎯 Protected route for specific users */}
                  <Route
                    path="/game"
                    element={
                      <ProtectedRoute user={user}>
                        <Game />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </Layout>
            </RequireAuth>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
